import { retrieveWizardState, saveWizardState } from "./localStorage"

(function redirection() {
  const selectors = {
    loginTemplate: '.template-login',
    registerTemplate: '.template-register',
    productTemplate: '.template-product',
  }
  const state = retrieveWizardState()
  if (state?.redirectAfterLogin) { // redirect if not on login/register page
    if (!(document.querySelector(selectors.loginTemplate) || document.querySelector(selectors.registerTemplate) || document.querySelector(selectors.productTemplate))) {
      const redirect = state.redirectAfterLogin
      state.redirectAfterLogin = ''
      if (state.active > 5)
        state.skipToLastStep = true
      saveWizardState(state)
      location.href = redirect
    }
  }
})()
